/**
 * Blog posts. Bodies live in app/content/blog/<slug>.ts.
 *
 * Articles are written in English only. The routes therefore point their
 * canonical URL at the English page and mark the localized variants noindex,
 * rather than claiming a translation that does not exist.
 */
export type BlogPost = {
  slug: string;
  /** ISO date, used for <time> and article:published_time. */
  date: string;
  readingMinutes: number;
  tag: string;
  image: string;
  imageAlt: string;
};

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: "what-claude-fable-5-means-for-learners",
    date: "2026-07-02",
    readingMinutes: 6,
    tag: "AI",
    image: "/img/quotes/idea_lamp.webp",
    imageAlt: "A desk lamp lighting a notebook beside a laptop",
  },
  {
    slug: "local-models-got-good",
    date: "2026-06-18",
    readingMinutes: 7,
    tag: "AI",
    image: "/img/quotes/software.webp",
    imageAlt: "A laptop screen showing source code",
  },
  {
    slug: "should-you-still-learn-to-code",
    date: "2026-05-27",
    readingMinutes: 5,
    tag: "Careers",
    image: "/img/quotes/solving.webp",
    imageAlt: "Two people working through a problem on a whiteboard",
  },
];

export function getPost(slug: string): BlogPost | undefined {
  return BLOG_POSTS.find((post) => post.slug === slug);
}

/** Newest first. */
export function sortedPosts(): BlogPost[] {
  return [...BLOG_POSTS].sort((a, b) => b.date.localeCompare(a.date));
}
